import * as Business   from '../../business';
import * as Forms      from '../../components/forms';
import { compose }     from 'redux';
import { connect }     from 'react-redux';
import { Fragment }    from 'react';
import { useState }    from 'react';
import Alert           from '../../components/alert';
import FetchFromServer from '../../components/fetch_from_server';
import Navbar          from '../../components/navbar';
import React           from 'react';


export default connect(
  (state, { businessID }) => ({
    business: Business.getBusiness(state, businessID),
    statuses: Business.getBusinessStatuses(state, businessID)
  }),
  (dispatch, { businessID }) => ({
    load: compose(dispatch, Business.loadBusiness, () => (businessID))
  })
)(GmbAddressPage);

export function GmbAddressPage({
  load,
  business,
  statuses,
  navigateTo
}) {

  return (
    <Fragment>
      <Navbar title="Verify Your Address"/>
      <FetchFromServer statuses={statuses} load={load} className="settings google-address">
        {business &&
          <AddressForm {...{ business, navigateTo }}/>
        }
      </FetchFromServer>
    </Fragment>
  );
}


function AddressForm({ business, navigateTo }) {
  const defaultRecord         = getDefaultAddressRecord(business);
  const [ record, setRecord ] = useState(defaultRecord);

  function save(addressFormRecord) {
    setRecord(addressFormRecord);
    const verificationAddress = getVerificationAddress(addressFormRecord);
    const props               = { verificationAddress };
    navigateTo(`/${business.id}/settings/business_profile/google/verify`, { props });
  }

  return (
    <Fragment>
      <div className="list media-list block inset">
        <p>
          To verify your location, we need to provide your mailing address to Google. This address will not be made public.
        </p>
        <Alert>
           Google will not accept P.O. boxes or mailboxes at remote locations.
        </Alert>
      </div>
      <div className="list media-list block inset">
        <Forms.Form {...{ record, save }}>
          <AddressFormFields/>
        </Forms.Form>
      </div>
    </Fragment>
  );
}

function AddressFormFields({ ...form }) {
  return (
    <div className="list">
      <ul>
        <Forms.Error {...form}/>
        <Forms.Input
          {...form}
          name="street"
          type="text"
          label="Address"
          required={true}
          autoComplete="off"/>
        <Forms.Input
          {...form}
          name="street2"
          type="text"
          label="Address Line 2"
          autoComplete="off"/>
        <Forms.Input
          {...form}
          name="city"
          type="text"
          label="City"
          required={true}
          autoComplete="off"/>
        <Forms.Input
          {...form}
          name="state"
          type="text"
          label="State"
          required={true}
          autoComplete="off"/>
        <Forms.Input
          {...form}
          name="postalCode"
          type="text"
          label="Postal Code"
          required={true}
          autoComplete="off"/>
        <Forms.Input
          {...form}
          name="countryCode"
          type="text"
          label="Country"
          placeholder="US"
          required={true}
          autoComplete="off"/>
        <Forms.Button {...form} label="Continue"/>
      </ul>
    </div>
  );
}

function getDefaultAddressRecord(business) {
  const { contact }     = business;
  const { street }      = contact;
  const { city }        = contact;
  const { state }       = contact;
  const { postalCode }  = contact;
  const { countryCode } = contact;
  const street2         = '';

  return {
    street,
    street2,
    city,
    state,
    postalCode,
    countryCode
  };
}

function getVerificationAddress(addressFormRecord) {
  const { street }      = addressFormRecord;
  const { street2 }     = addressFormRecord;
  const { city }        = addressFormRecord;
  const { state }       = addressFormRecord;
  const { postalCode }  = addressFormRecord;
  const { countryCode } = addressFormRecord;

  const address = {
    languageCode: 'en',
    regionCode:   countryCode,
    postalCode,
    addressLines: [
      street,
      street2,
      [ city, state ].join(', ')
    ].filter(item => item)
  };

  return address;
}
